/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, ChangeEvent } from "react";
import useUser from "hooks/useUser";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAppState } from "providers/AppState";
import Box from "@mui/material/Box";
import { apolloClient } from "providers/Apollo";
import { CircularProgress, Stack, useMediaQuery } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import twitter from "assets/images/twitter.png"
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import SportsBaseballOutlinedIcon from "@mui/icons-material/SportsBaseballOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Image } from "semantic-ui-react";
import { useNotifications } from "providers/Notification";
import useUserProfile from "hooks/useUserProfile";
import { ApolloError, useMutation, useQuery } from "@apollo/client";
import { ATHLETE_EARNINGS_SUMMARY, ATHLETE_HEAD_SHOT, UPDATE_APPROVAL_POPUP } from "../../queries";
import {
  AthleteTransactionSummaryResponse,
  HeadShotUploadArgs,
  StripeVerificationStatus,
} from "../../types";
import { AthleteNotFound } from "components/AthleteNotFound/AthleteNotFound";
import {
  formatCurrency,
  insertApiResponseDataDog,
  insertApiResponseDataDogError,
} from "utils";
import { AthleteImage } from "components/AthleteProfileHeader/AthleteImage";
import EditIcon from "@mui/icons-material/Edit";
import useUserType from "hooks/useUserType";
import { Dot } from "components/TextDot/TextDot";
import ReadMore from "components/ReadMore";
import Snapchat from "assets/icons/snapchat-64.png";
import SnapchatIn from "assets/icons/snapchat-inActive-64.png";
import "react-multi-carousel/lib/styles.css";
import DialogBoxCarousal from "./DialogBoxCarousal";
import whatcanido from "assets/images/what_can_do_fan.png";
import transparency from "assets/images/transparency.png";
import howItWorksBusiness from "assets/images/how-it-works-business.png";
import whynilluniversal from "assets/images/what-is-nil-universal.png";
import whyusemynillpayfan from "assets/images/whyusemynillpayfan.png";
import howItWorksBusinessStep1 from "assets/images/how-it-works-business/Frame-1.png";
import howItWorksBusinessStep2 from "assets/images/how-it-works-business/Frame-2.png";
import howItWorksBusinessStep3 from "assets/images/how-it-works-business/Frame-3.png";
import howItWorksBusinessStep4 from "assets/images/how-it-works-business/Frame-4.png";
import howItWorksBusinessStep5 from "assets/images/how-it-works-business/Frame-5.png";
import howItWorksBusinessStep6 from "assets/images/how-it-works-business/Frame-6.png";
import howItWorksBusinessStep7 from "assets/images/how-it-works-business/Frame-7.png";
import howItWorksBusinessmobileStep1 from "assets/images/how-it-works-business/mobile/For_Business_1.png";
import howItWorksBusinessmobileStep2 from "assets/images/how-it-works-business/mobile/For_Business_2.png";
import howItWorksBusinessmobileStep3 from "assets/images/how-it-works-business/mobile/For_Business_3.png";
import howItWorksBusinessmobileStep4 from "assets/images/how-it-works-business/mobile/For_Business_4.png";
import howItWorksBusinessmobileStep5 from "assets/images/how-it-works-business/mobile/For_Business_5.png";
import howItWorksBusinessmobileStep6 from "assets/images/how-it-works-business/mobile/For_Business_6.png";
import howItWorksBusinessmobileStep7 from "assets/images/how-it-works-business/mobile/For_Business_7.png";
import Howtouseathlete from "assets/images/Howtouseathlete.png";
import HowtouseathleteMobile from "assets/images/HowToUseCorporateMobile.png";
import AthleteTranspancy01 from "assets/images/TranspancyAthlete/AthleteTranspancy01.png";
import AthleteTranspancymobile01 from "assets/images/TranspancyAthlete/mobile/AthleteTranspancy01.png";
import WhyUse01 from "assets/images/whyuseAthleteCorporate/WhyUse01.png";
import WhyUse02 from "assets/images/whyuseAthleteCorporate/WhyUse02.png";
import WhyUse03 from "assets/images/whyuseAthleteCorporate/WhyUse03.png";
import WhyUse04 from "assets/images/whyuseAthleteCorporate/WhyUse04.png";
import WhyUseMobile01 from "assets/images/whyuseAthleteCorporate/mobile/For_Corporate_1.png";
import WhyUseMobile02 from "assets/images/whyuseAthleteCorporate/mobile/For_Corporate_2.png";
import WhyUseMobile03 from "assets/images/whyuseAthleteCorporate/mobile/For_Corporate_3.png";
import WhyUseMobile04 from "assets/images/whyuseAthleteCorporate/mobile/For_Corporate_4.png";
import how_it_works_fan_01 from "assets/images/athlete-profile/direct-pay/01/01.png";
import how_it_works_fan_02 from "assets/images/athlete-profile/direct-pay/01/02.png";
import how_it_works_fan_03 from "assets/images/athlete-profile/direct-pay/01/03.png";
import how_it_works_fan_04 from "assets/images/athlete-profile/direct-pay/01/04.png";
import how_it_works_fan_05 from "assets/images/athlete-profile/direct-pay/01/05.png";
import how_it_works_fan_06 from "assets/images/athlete-profile/direct-pay/01/06.png";
import how_it_works_fan_mobile_01 from "assets/images/athlete-profile/direct-pay/01/mobile/01.png";
import how_it_works_fan_mobile_02 from "assets/images/athlete-profile/direct-pay/01/mobile/02.png";
import how_it_works_fan_mobile_03 from "assets/images/athlete-profile/direct-pay/01/mobile/03.png";
import how_it_works_fan_mobile_04 from "assets/images/athlete-profile/direct-pay/01/mobile/04.png";
import how_it_works_fan_mobile_05 from "assets/images/athlete-profile/direct-pay/01/mobile/05.png";
import how_it_works_fan_mobile_06 from "assets/images/athlete-profile/direct-pay/01/mobile/06.png";
import fan_legal_fan_01 from "assets/images/fanlegal/Frame-1.png";
import fan_legal_fan_02 from "assets/images/fanlegal/Frame-2.png";
import fan_legal_fan_03 from "assets/images/fanlegal/Frame-3.png"
import fan_legal_fan_mobile_01 from "assets/images/fanlegal/mobile/About_1.png";
import fan_legal_fan_mobile_02 from "assets/images/fanlegal/mobile/About_2.png";
import fan_legal_fan_mobile_03 from "assets/images/fanlegal/mobile/About_3.png";
import safe_banner from "assets/images/mynilpaysafeandlegal.png";
import universalnillpaystep1 from "assets/images/what-is-universal-nil/Frame-1.png";
import universalnillpaystep2 from "assets/images/what-is-universal-nil/Frame-2.png";
import universalnillpaystep3 from "assets/images/what-is-universal-nil/Frame-3.png";
import universalnillpaymobilestep1 from "assets/images/what-is-universal-nil/mobile/About_1.png";
import universalnillpaymobilestep2 from "assets/images/what-is-universal-nil/mobile/About_2.png";
import universalnillpaymobilestep3 from "assets/images/what-is-universal-nil/mobile/About_3.png";
import whyusestep2 from "assets/images/athlete-profile/direct-pay/02/02.png";
import whyusestep2mobile from "assets/images/athlete-profile/direct-pay/02/mobile/HowToUseIt.png";
import whyusemynilpay02 from "assets/images/athlete-profile/direct-pay/03/02.png";
import whyusemynilpay02mobile from "assets/images/athlete-profile/direct-pay/03/mobile/WhyToUse.png";
import paymentTransparency01 from "assets/images/athlete-profile/direct-pay/04/01.png";
import paymentTransparency02 from "assets/images/athlete-profile/direct-pay/04/02.png";
import paymentTransparencymobile01 from "assets/images/athlete-profile/direct-pay/04/mobile/01.png";
import paymentTransparencymobile02 from "assets/images/athlete-profile/direct-pay/04/mobile/02.png";
import about_banner01 from "assets/images/athlete-profile/about/01.png";
import how_it_works_fan from "assets/images/how-it-works-for-fan.png";
import about from "assets/images/about.png";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import Carousel from "react-multi-carousel";
import { Post } from "providers/Fetch";
import AccountInfo from "./accountInfo/info";
import { getPaymentRequirementsStatus } from "./helper";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
interface ProfileProps {
  athleteId: string;
  showApprovalPopup?: boolean;
}

const Profile = React.memo(function Profile({ athleteId, showApprovalPopup = false }: ProfileProps) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const notify = useNotifications();
  const [userProfileData, setUserProfileData] = React.useState<any>("");
  const [file, setFile] = useState<File>();
  const [imageloader, setImageLoader] = useState<boolean>(false);
  const [imgUrl, setImgUrl] = useState("");
  const [searchParams] = useSearchParams();
  const [popUpImages, setPopUpImages] = useState<any>([]);
  const userType = useUserType();
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [approvalPopupOpen, setApprovalPopupOpen] = React.useState(showApprovalPopup);

  const how_its_for_fan_flow = [
    ...(isMobile
      ? [
        {
          imageUrl: how_it_works_fan_mobile_01,
        },
        {
          imageUrl: how_it_works_fan_mobile_02,
        },
        {
          imageUrl: how_it_works_fan_mobile_03,
        },
        {
          imageUrl: how_it_works_fan_mobile_04,
        },
        {
          imageUrl: how_it_works_fan_mobile_05,
        },
        {
          imageUrl: how_it_works_fan_mobile_06,
        },
      ]
      : [
        {
          imageUrl: how_it_works_fan_01,
        },
        {
          imageUrl: how_it_works_fan_02,
        },
        {
          imageUrl: how_it_works_fan_03,
        },
        {
          imageUrl: how_it_works_fan_04,
        },
        {
          imageUrl: how_it_works_fan_05,
        },
        {
          imageUrl: how_it_works_fan_06,
        },
      ]),
  ];

  const { loading, data } = useUserProfile(athleteId);
  const [updateImage] = useMutation<HeadShotUploadArgs>(ATHLETE_HEAD_SHOT);
  const [updateApprovalPopup] = useMutation(UPDATE_APPROVAL_POPUP);

  const howItworksBusiness = isMobile
    ? [
      {
        imageUrl: howItWorksBusinessmobileStep1,
      },
      {
        imageUrl: howItWorksBusinessmobileStep2,
      },
      {
        imageUrl: howItWorksBusinessmobileStep3,
      },
      {
        imageUrl: howItWorksBusinessmobileStep4,
      },
      {
        imageUrl: howItWorksBusinessmobileStep5,
      },
      {
        imageUrl: howItWorksBusinessmobileStep6,
      },
      {
        imageUrl: howItWorksBusinessmobileStep7,
      },
    ]
    : [
      {
        imageUrl: howItWorksBusinessStep1,
      },
      {
        imageUrl: howItWorksBusinessStep2,
      },
      {
        imageUrl: howItWorksBusinessStep3,
      },
      {
        imageUrl: howItWorksBusinessStep4,
      },
      {
        imageUrl: howItWorksBusinessStep5,
      },
      {
        imageUrl: howItWorksBusinessStep6,
      },
      {
        imageUrl: howItWorksBusinessStep7,
      },
    ];

  const howToUse = [
    ...(isMobile
      ? [
        {
          imageUrl: HowtouseathleteMobile,
        },
      ]
      : [
        {
          imageUrl: Howtouseathlete,
        },
      ]),
  ];

  const PaymentTransp = isMobile
    ? [
      {
        imageUrl: AthleteTranspancymobile01,
      },
    ]
    : [
      {
        imageUrl: AthleteTranspancy01,
      },
    ];

  const whyshouldI = isMobile
    ? [
      {
        imageUrl: WhyUseMobile01,
      },
      {
        imageUrl: WhyUseMobile02,
      },
      {
        imageUrl: WhyUseMobile03,
      },
      {
        imageUrl: WhyUseMobile04,
      },
    ]
    : [
      {
        imageUrl: WhyUse02,
      },
      {
        imageUrl: WhyUse01,
      },
      {
        imageUrl: WhyUse03,
      },
      {
        imageUrl: WhyUse04,
      },
    ];

  const aboutbanner = [
    {
      imageUrl: about_banner01,
      ...(isMobile ? { height: "55vh" } : {}),
    },
  ];

  const whyusemynilpay = [
    ...(isMobile
      ? [
        {
          imageUrl: whyusemynilpay02mobile,
        },
      ]
      : [
        {
          imageUrl: whyusemynilpay02,
        },
      ]),
  ];

  const whyusemynillpay = [
    ...(isMobile
      ? [
        {
          imageUrl: whyusestep2mobile,
        },
      ]
      : [
        {
          imageUrl: whyusestep2,
        },
      ]),
  ];

  const myNILpayPaymentTransparency = [
    ...(isMobile
      ? [
        {
          imageUrl: paymentTransparencymobile01,
        },
        {
          imageUrl: paymentTransparencymobile02,
        },
      ]
      : [
        {
          imageUrl: paymentTransparency01,
        },
        {
          imageUrl: paymentTransparency02,
        },
      ]),
  ];

  const handleClickOpenMyNillPayFan = () => {
    setPopUpImages(whyusemynillpay);
    setOpen(true);
  };

  const handleClickOpenTransparency = () => {
    setOpen(true);
    setPopUpImages(myNILpayPaymentTransparency);
  };

  const handleClickOpenHowItWorkBusiness = () => {
    setOpen(true);
    setPopUpImages(howItworksBusiness);
  };

  const handleClickOpenHowTouse = () => {
    setOpen(true);
    setPopUpImages(howToUse);
  };

  const handleClickOpenWhyShouldIuse = () => {
    setOpen(true);
    setPopUpImages(whyshouldI);
  };
  const handleClickOpenTranparency = () => {
    setOpen(true);
    setPopUpImages(PaymentTransp);
  };

  const handleAboutOpen = () => {
    setOpen(true);
    setPopUpImages(aboutbanner);
  };
  const handleClickOpenworksfan = () => {
    setOpen(true);
    setPopUpImages(how_its_for_fan_flow);
  };

  const handleClickOpenWhatCando = () => {
    setPopUpImages(whyusemynilpay);
    setOpen(true);
  };

  // Handle approval popup close
  const handleApprovalPopupClose = async () => {
    try {
      await updateApprovalPopup();
      setApprovalPopupOpen(false);
      notify.success("Thank you for confirming your approval status");
    } catch (error) {
      notify.error("Failed to update approval status");
    }
  };

  useEffect(() => {
    if (data) {
      setUserProfileData(data.userProfile);
    }
  }, [data]);

  const { data: athleteData } = useQuery<AthleteTransactionSummaryResponse>(
    ATHLETE_EARNINGS_SUMMARY,
    {
      onError: (error: ApolloError) => {
        insertApiResponseDataDog(
          "updateHeadshotDetailsApi(error)",
          error,
          "error"
        );
        insertApiResponseDataDogError(error, "updateHeadshotDetailsApi(error)");
        notify.error(error.message);
      },
      onCompleted: (data) => {
        insertApiResponseDataDog(
          "updateHeadshotDetailsApi(success)",
          data,
          "info"
        );
      },
    }
  );

  const { publicProfile } = useAppState();

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  useEffect(() => {
    apolloClient.cache.reset();
    // const transaction = searchParams.get("transaction");
    // if (transaction === "completed") {
    //     setShowFeedbackModal(true);
    // }
  }, [searchParams]);

  if (publicProfile) {
    // if the user comes from a public profile
    // redirect to the same profile after they register
    return <Navigate to={`/home/athlete/${publicProfile}`} replace />;
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <>{children}</>
          </Box>
        )}
      </div>
    );
  }

  useEffect(() => {
    function setUploadImge() {
      if (file) {
        setImageLoader(true);
        const formdata = new FormData();
        // const myHeaders = new Headers();
        formdata.append("file", file);
        formdata.append("type", "headshot");
        // myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
        Post(`${process.env.REACT_APP_SERVER_URI}/file/upload`, formdata)
          .then((response) => response.text())
          .then((result) => {
            setImageLoader(false);
            setImgUrl(result);
            setImageMutation(result);
            insertApiResponseDataDog(
              "updateHeadshotDetailsApi(success)",
              result,
              "info"
            );
          })
          .catch((err) => {
            setImageLoader(false);
            insertApiResponseDataDog(
              "updateHeadshotDetailsApi(error)",
              err,
              "error"
            );

            notify.error(err.message);
          });
      }
    }
    setUploadImge();
  }, [file]);

  const setImageMutation = async (result: string) => {
    setImageLoader(true);
    try {
      setImageLoader(false);
      const res = await updateImage({
        variables: {
          imageUrl: result,
        },
      });
      insertApiResponseDataDog(
        "updateHeadshotDetailsApi(success)",
        res?.data,
        "info"
      );

      if (res?.data?.updateHeadshotDetails) {
        setUserProfileData({
          ...userProfileData,
          imageUrl: imgUrl,
        });
        apolloClient.cache.reset();

        notify.success("Image Sucessfully Updated");
      }
    } catch (error) {
      insertApiResponseDataDog(
        "updateHeadshotDetailsApi(error)",
        error,
        "error"
      );

      setImageLoader(false);
      notify.error("Upload Failed");
    }
  };

  const handleChangeImage = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };
  //  const completeNumber = complteCount?.listAthleteTransactions.itemTotal || 0;
  const athleteTotalEarnings =
    athleteData?.athleteTransactionSummary.totalEarnings || 0;

  if (loading) return <CircularProgress />;
  if (!data) return <AthleteNotFound />;

  const { firstName, lastName, school, isAlumni, socialMedia } =
    data.userProfile;
  const athleteSport = data?.userProfile.athleteSport;
  const str = firstName + " " + lastName;
  const words = str.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0]
      ? words[i][0]?.toUpperCase() + words[i].substring(1)
      : "";
  }
  const fullName = words.join(" ");
  const universalNillPay = isMobile
    ? [
      {
        imageUrl: universalnillpaymobilestep3,
      },
      {
        imageUrl: universalnillpaymobilestep1,
      },
      {
        imageUrl: universalnillpaymobilestep2,
      },
    ]
    : [
      {
        imageUrl: universalnillpaystep3,
      },
      {
        imageUrl: universalnillpaystep1,
      },
      {
        imageUrl: universalnillpaystep2,
      },
    ];
  const fanLegal = isMobile
    ? [
      { imageUrl: fan_legal_fan_mobile_01 },
      { imageUrl: fan_legal_fan_mobile_02 },
      { imageUrl: fan_legal_fan_mobile_03 },
    ]
    : [
      { imageUrl: fan_legal_fan_01 },
      { imageUrl: fan_legal_fan_02 },
      { imageUrl: fan_legal_fan_03 },
    ];

  const handleClickOpenBusinessUniversal = () => {
    setOpen(true);
    setPopUpImages(universalNillPay);
  };
  const handleClickOpenSafe = () => {
    setPopUpImages(fanLegal);
    setOpen(true);
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <>
      <Box
        className="main-home"
        sx={{
          position: "absolute",
          top: "0px",
          left: "0px",
          right: "0px",
          bottom: "0px",
        }}
        paddingTop={{ xs: "10px", md: "0" }}
      >
        <Box className="main-home__header">
          <Grid container spacing={2} sx={{ alignItems: "baseline" }}>
            <Grid item xs={8} sx={{ textAlign: "right", paddingRight: "10px" }}>
              <h4>
                First-of-its-kind experience to direct-pay college athletes
              </h4>
            </Grid>
            <Grid item xs={4} sx={{ justifyContent: "flex-end" }}>
              <Box
                className="user"
                sx={{ justifyContent: "flex-end", alignItems: "center" }}
              >
                <span>
                  <strong>{fullName}</strong>
                  <small>Athlete</small>
                </span>
                <AccountCircleIcon />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box className="main-home__body">
          <Box className="main-home__athlete">
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={8}
                sm={12}
                sx={{ ...(isMobile ? { paddingLeft: "0px !important" } : {}) }}
              >
                <Box className="profile">
                  <Box className="profile__info">
                    <Stack sx={{ position: "relative" }}>
                      {/* <img src={AthImg} alt="" /> */}
                      {userProfileData?.imageUrl === undefined ||
                        imageloader === true ? (
                        <Stack sx={{ width: "140px" }}>
                          <CircularProgress />
                        </Stack>
                      ) : (
                        <AthleteImage
                          imageUrl={userProfileData?.imageUrl}
                          sport={athleteSport.sport.name}
                        />
                      )}
                      {userType == "athlete" ? (
                        <Stack
                          sx={{
                            position: "absolute",
                            left: "85px",
                            top: "6px",
                            width: 30,
                            height: 30,
                            cursor: "pointer",
                            borderRadius: 60,
                            backgroundColor: "#592ee5",
                          }}
                        >
                          <input
                            accept="image/*"
                            id="icon-button-file"
                            type="file"
                            style={{ display: "none" }}
                            onChange={handleChangeImage}
                          />
                          <label htmlFor="icon-button-file">
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                            >
                              <EditIcon
                                sx={{
                                  width: 30,
                                  height: 20,
                                  left: -26,
                                  color: "#fff",
                                  position: "absolute",
                                  top: 2,
                                }}
                              />
                            </IconButton>
                          </label>
                        </Stack>
                      ) : (
                        ""
                      )}
                    </Stack>

                    <span>
                      <strong>{fullName}</strong>
                      <small>
                        <em>
                          <>
                            <LocationOnOutlinedIcon />
                            {school.name}
                          </>
                        </em>
                        <em>
                          <>
                            <SportsBaseballOutlinedIcon />{" "}
                            {athleteSport.sport.name}
                          </>
                        </em>
                        <em>
                          <PermIdentityOutlinedIcon />
                          {isAlumni ? <>Alumni</> : <> Student</>}
                        </em>
                        <em>
                          {athleteSport.sportDetails.position ? (
                            <>
                              {" "}
                              <Dot />
                              {athleteSport.sportDetails.position}
                            </>
                          ) : (
                            ""
                          )}
                        </em>
                        <em>
                          {athleteSport.jerseyNumber ? (
                            <>
                              {" "}
                              <Dot />
                              &#35;{athleteSport.jerseyNumber}
                            </>
                          ) : (
                            ""
                          )}
                        </em>
                      </small>
                      <small className="social" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {socialMedia.facebook_link ? (
                          <a
                            href={`https://www.facebook.com/${socialMedia.facebook_link}`}
                            rel="noreferrer"
                            target="_blank"
                          >
                            <FacebookIcon sx={{ color: "#ffffff" }} />
                          </a>
                        ) : (
                          <FacebookIcon sx={{ color: "#c096e3" }} />
                        )}
                        {socialMedia.twitter_link ? (
                          <a
                            href={`https://www.twitter.com/${socialMedia.twitter_link}`}
                            rel="noreferrer"
                            target="_blank"
                          >
                            <img
                              src={twitter}
                              alt="Twitter"
                              style={{ width: "14px", height: "14px", right: "10px" }}
                            />
                          </a>
                        ) : (
                          <img
                            src={twitter}
                            alt="Twitter"
                            style={{
                              width: "14px",
                              height: "14px",
                              opacity: 0.6,
                              marginLeft: "-15px"
                            }}
                          />
                        )}
                        {socialMedia.instagram_link ? (
                          <a
                            href={`https://www.instagram.com/${socialMedia.instagram_link}`}
                            rel="noreferrer"
                            target="_blank"
                          >
                            <InstagramIcon sx={{ color: "#ffffff" }} />
                          </a>
                        ) : (
                          <InstagramIcon sx={{ color: "#c096e3" }} />
                        )}
                        {socialMedia.snapchat_link ? (
                          <a
                            href={`https://www.snapchat.com/${socialMedia.snapchat_link}`}
                            rel="noreferrer"
                            target="_blank"
                          >
                            <img src={Snapchat} style={{
                              width: "14px",
                              height: "14px",
                              opacity: 0.6,
                              marginLeft: "-15px"
                            }} />
                          </a>
                        ) : (
                          <img src={SnapchatIn} style={{
                            width: "14px",
                            height: "14px",
                            opacity: 0.6,
                            marginLeft: "-15px"
                          }} />
                        )}
                      </small>
                    </span>
                  </Box>
                  <Box>
                    <h5>Bio</h5>
                    <Box marginBottom={"44px"}>
                      <ReadMore text={athleteSport.sportDetails.bio} />
                    </Box>
                    {/* <h5>Honors & Awards</h5>
                                    <ul>
                                        <li>Honor Roll - Advanced Business Courses</li>
                                        <li>Leadership Award</li>
                                    </ul> */}
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={4} sm={12}>
                <Box className="total-earnings">
                  <Box className="total-earnings__fans">
                    <span>
                      <small>Favorites</small>
                      <strong>
                        {data.userProfile.athleteProfileStats.favorites}
                      </strong>
                    </span>
                    <span>
                      <small>Fans</small>
                      <strong>
                        {data.userProfile.athleteProfileStats.supporters}
                      </strong>
                    </span>
                  </Box>
                  <Box className="total-earnings__earnings">
                    <span>Total Earnings</span>
                    <strong>{formatCurrency(athleteTotalEarnings)}</strong>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Dialog
            className="carousal-dialog"
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="md"
          >
            <DialogTitle id="alert-dialog-title">
              <div style={{ float: "right" }}>
                <IconButton onClick={handleClose}>
                  {" "}
                  <div style={{ float: "right" }}>
                    <CloseIcon />
                  </div>
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: "100%" }}>
              <DialogBoxCarousal popUpImages={popUpImages} />
            </DialogContent>
          </Dialog>

          {/* Approval Popup */}
          <Dialog
            open={approvalPopupOpen}
            onClose={handleApprovalPopupClose}
            aria-labelledby="approval-dialog-title"
            aria-describedby="approval-dialog-description"
            PaperProps={{
              sx: {
                width: '320px',
                height: '160px',
                minHeight: '160px',
                maxHeight: '160px',
                borderRadius: '12px',
                overflow: 'hidden',
                margin: '0 auto',
                // Hide scrollbars completely
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                scrollbarWidth: 'none', // Firefox
                msOverflowStyle: 'none', // IE and Edge
              }
            }}
            container={() => document.body}
          >
            <DialogTitle
              id="approval-dialog-title"
              sx={{
                padding: '10px 20px 6px',
                height: '45px',
                display: 'flex',
                alignItems: 'center',
                // Hide scrollbars in title
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: '0.95rem',
                  lineHeight: 1.2,
                  fontWeight: 'bold'
                }}
              >
                Payment Verification Status
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleApprovalPopupClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                  padding: '2px',
                }}
              >
                <CloseIcon sx={{ fontSize: '18px' }} />
              </IconButton>
            </DialogTitle>

            <DialogContent
              sx={{
                padding: '10px 20px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                // Hide scrollbars in content
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  lineHeight: 1.3,
                  margin: 0,
                  textAlign: 'center',
                  // Hide scrollbars in typography
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                You have been approved by our payment processor.
              </Typography>
            </DialogContent>
            <DialogActions
              sx={{
                padding: '6px 20px 10px',
                height: '55px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // Hide scrollbars in actions
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
              <Button
                onClick={handleApprovalPopupClose}
                autoFocus
                sx={{
                  fontSize: '0.9rem',
                  backgroundColor: '#592EE5',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#4a25d4',
                  }
                }}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>

          <Box className="main-home__tabs fan_page">
            <Box>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Direct-Pay" {...a11yProps(0)} />
                <Tab label="corporate" {...a11yProps(1)} />
                <Tab label="About" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Carousel
                swipeable={isMobile}
                draggable={true}
                showDots={true}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={false}
                autoPlay={true}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={"desktop"}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-20-px"
              >
                {/* <Grid container spacing={2}>
                                <Grid item xs={3}> <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenworksfan}
                >
                  <div>How does myNILpay works?</div>
                  <Image src={how_it_works_fan} alt="Tabs Image" />{" "}
                </div>
                {/* </Item>
                                </Grid> */}
                {/* <Grid item xs={3}>
                                    <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenMyNillPayFan}
                >
                  {" "}
                  <div>How to use myNILpay?</div>
                  <Image src={whatcanido} alt="Tabs Image" />
                </div>
                {/* </Item>
                                </Grid> */}
                {/* <Grid item xs={3}>
                                    <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenWhatCando}
                >
                  {" "}
                  <div>Why should I use myNILpay?</div>
                  <Image src={whyusemynillpayfan} alt="Tabs Image" />
                </div>
                {/* </Item>
                                </Grid> */}
                {/* <Grid item xs={3}> 
                                <Item>  */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenTransparency}
                >
                  <div>Payment Transparency</div>
                  <Image src={transparency} alt="Tabs Image" />
                </div>
                {/* </Item>
                                </Grid> */}
                {/* </Grid> */}
              </Carousel>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Carousel
                swipeable={isMobile}
                draggable={true}
                showDots={true}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={false}
                autoPlay={true}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={"desktop"}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-20-px"
              >
                {/* <Grid container spacing={2}>
                                <Grid item xs={3}> <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenHowItWorkBusiness}
                >
                  {" "}
                  <div>How does myNILpay works?</div>
                  <Image src={howItWorksBusiness} alt="Tabs Image" />
                </div>
                {/* </Item>
                                </Grid> */}
                {/* <Grid item xs={3}> 
                                <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenHowTouse}
                >
                  {" "}
                  <div>How to use myNILpay?</div>
                  <Image src={whatcanido} alt="Tabs Image" />
                </div>
                {/* </Item>
                                </Grid> */}
                {/* <Grid item xs={3}> 
                                <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenWhyShouldIuse}
                >
                  {" "}
                  <div>Why should I use myNILpay?</div>
                  <Image src={whyusemynillpayfan} alt="Tabs Image" />
                </div>
                {/* </Item>
                                </Grid> */}
                {/* <Grid item xs={3}> 
                                <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenTranparency}
                >
                  {" "}
                  <div>Payment Transparency</div>
                  <Image src={transparency} alt="Tabs Image" />
                </div>
                {/* </Item>
                                </Grid> */}
                {/* </Grid> */}
              </Carousel>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Carousel
                swipeable={isMobile}
                draggable={true}
                showDots={true}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={false}
                autoPlay={true}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={"desktop"}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-20-px"
              >
                {/* <Grid container spacing={2}>
                                <Grid item xs={3}> <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenBusinessUniversal}
                >
                  <div>What is NIL</div>
                  <Image
                    src={whynilluniversal}
                    className="whyUseMyNilpay"
                    alt="Tabs Image"
                  />
                </div>
                {/* </Item></Grid> */}
                {/* <Grid item xs={3}>  <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleAboutOpen}
                >
                  <div>About Us</div>
                  <Image
                    className="whyUseMyNilpay"
                    src={about}
                    alt="Tabs Image"
                  />
                </div>
                {/* </Item></Grid> */}
                {/* <Grid item xs={3}> <Item> */}
                <div
                  className="carousalmainContainer"
                  onClick={handleClickOpenSafe}
                >
                  <div>myNILpay is SAFE and LEGAL-Universal</div>
                  <Image
                    src={safe_banner}
                    className="whyUseMyNilpay"
                    alt="Tabs Image"
                  />
                </div>
                {/* </Item></Grid> */}
                {/* </Grid> */}
              </Carousel>
            </TabPanel>
          </Box>
        </Box>
      </Box>
    </>
  );
})

export function AthleteHome() {
  const user: any = useUser(true);
  if (user.loading) return <CircularProgress />;

  // Step 1: User must have a connected account
  if (!user?.paymentConnectedAccountId) {
    return <Navigate to="/home/payment" replace />;
  }

  // Step 2: Determine payment requirements
  const { status } = getPaymentRequirementsStatus(user);
  const userRequirements = JSON.parse(user?.paymentRequirements || "{}");
  const isVerified = user?.paymentVerificationStatus === StripeVerificationStatus.VERIFIED;
  const isPending = user?.paymentVerificationStatus === StripeVerificationStatus.PENDING;
  const shouldShowApprovalPopup = user?.showApprovalPopup === true && isVerified;

  // Step 3: Handle by status
  switch (status) {

    case "verification_pending":
      return <AccountInfo />;;

    case "personal_missing":
      return <Navigate to="/home/PersonalDetails" replace />;

    case "bank_missing":
      return <Navigate to="/bankAccountUpdate" replace />;

    case "both_missing":
      return <Navigate to="/home/PersonalDetails" replace />;

    case "complete":
    default:
      break;
  }

  // Step 4: Handle edge cases — pending / migrant / partially verified
  if (
    user?.isMigrant ||
    (user?.paymentVerificationStatus &&
      user.paymentVerificationStatus !== StripeVerificationStatus.VERIFIED)
  ) {
    return <AccountInfo />;
  }

  // Step 5: Handle Stripe pending verification with inconsistent data
  if (isPending) {
    const hasPending = userRequirements?.pending_verification?.length === 0 && userRequirements?.currently_due?.length > 0;
    const hasPendingVerification = userRequirements?.pending_verification?.length > 0;

    if (hasPendingVerification) {
      return <AccountInfo />;
    } else if (hasPending) {
      return <Navigate to="/home/PersonalDetails" replace />;
    }
    return <AccountInfo />;
  }

  //Step 6: Default — verified user
  return (
    <Box>
      <Profile athleteId={user.id} showApprovalPopup={shouldShowApprovalPopup} />
    </Box>
  );
}

export default AthleteHome;